// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-namibia/calculator-namibia-business-loan/calculator-namibia-business-loan.component.scss
// module id = 601
// module chunks = 0